export const TOOL_TASK = 'change-user-account';
export const TOOL_TITLE = 'Change User\'s Account';
export const TOOL_PROGRESS_LABEL = 'Bulk user\'s account changing progress...';
export const FILE_NAME = 'Change-user-account-report';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once changing user\'s account finishes';
export const FILE_HEADERS = {
    userId: 'User Id',
    userEmail: 'User Email',
    oldAccountId: 'Old Account Id',
    oldAccountName: 'Old Account Name',
    newAccountId: 'New Account Id',
    newAccountName: 'New Account Name',
    actionStatus: 'Action Status',
};

export const MODAL_WIDTH = 450;
